import { render } from "./AllSubject.vue?vue&type=template&id=53b679a6"
import script from "./AllSubject.vue?vue&type=script&lang=js"
export * from "./AllSubject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__